import { cn } from '@/lib/utils/helpers'
import type { SectionHeaderProps } from './SectionHeader.types'

export function SectionHeader({
  icon,
  title,
  subtitle,
  className,
  titleClassName,
}: SectionHeaderProps) {
  return (
    <div className={cn("mb-3 flex items-center gap-2.5", className)}>
      <span
        className="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-[#eaf4ff] text-[#1597ff]"
        aria-hidden="true"
      >
        {icon}
      </span>
      <div className="min-w-0">
        <h3 className={cn("text-sm font-bold text-slate-900", titleClassName)}>{title}</h3>
        {subtitle ? <p className="text-xs text-slate-500">{subtitle}</p> : null}
      </div>
    </div>
  )
}
